module.exports = __webpack_public_path__ + "img/error-dark.8595e891.svg";